export default "__VITE_ASSET__222ae2ea__"